import { Grid } from '@mui/material';
import * as React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { SearchData, ISearchData } from '../../models';
import {DateRangeSelector, GenerateCheckboxes} from '..';
import styles from './Filter.module.scss';

interface IFilerProps {
    onSearch: any;
}
interface IFilterState {
    divisionClicked: boolean;
    documentClicked: boolean;
    agencyClicked: boolean;
    agency: any;
    agencySelected: string;
    division: ISearchData[];
    documentType: ISearchData[];
}

export class Filter extends React.Component<IFilerProps, IFilterState> {
    private searchData = new SearchData();

    constructor(props: IFilerProps) {
        super(props);

        this.state = {
            divisionClicked: false,
            documentClicked: false,
            agencyClicked: false,
            agencySelected: '',
            agency: [],
            division: [],
            documentType: []
        }
        
    }

    async componentDidMount() {
        let as: string = JSON.parse(localStorage.getItem('agency') || '')
        this.setState({
            division: await this.searchData.Division(),
            documentType: await this.searchData.DocumentType(),
            agency: await this.searchData.Agency(),
            agencySelected: as,
        });
    }

    public render() {
        return (
            <div className={styles.filter}>
                <Grid container spacing={1} className={styles.grid}>
                    <Grid item xs={4}>
                        {this.wrapCheckboxes('Document Type', this.state.documentType, this.state.documentClicked, this.onDocumentClick.bind(this))}
                    </Grid>
                    <Grid item xs={4}>
                         {this.wrapCheckboxes('Division', this.state.division, this.state.divisionClicked, this.onDivisionClick.bind(this))}
                    </Grid>
                    <Grid item xs={4}>
                        <h4>Search Date Range</h4>
                        <DateRangeSelector 
                            startDate={JSON.parse(localStorage.getItem('startDate') || '')} 
                            endDate={JSON.parse(localStorage.getItem('endDate') || '')} />
                        <h4>Agency</h4>
                        <Dropdown placeholder='Agency' search button fluid multiple selection options={this.state.agency} value={this.state.agencySelected} defaultValue onChange={(e, d) => this.onAgencyHandleChange(e, d)} className={styles.dropDownSelection} />
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <button onClick={this.props.onSearch} className={styles.searchBtn}>
                                Search
                              </button>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }

    private wrapCheckboxes(title: string, data: ISearchData[], clicked: boolean, onClick: any) {
        return (
            <>
                <h4>{title}</h4>
                <div className={styles.checkboxContainer}>
                    {data.length !== 0 ?
                    <GenerateCheckboxes searchData={data} title={title} /> :
                    <div />}
                </div>
            </>
        ) 
    }

    private onDivisionClick() {
        this.setState({
            divisionClicked: !this.state.divisionClicked
        });
    }

    private onDocumentClick() {
        this.setState({
            documentClicked: !this.state.documentClicked
        });
    }

    private onAgencyHandleChange(event: any, data: any) {

        this.setState({
            agencySelected: data.value
        });

        localStorage.setItem("agency", JSON.stringify(data.value));           
    }
}